import React from 'react';
import { FlexibleCRUDTable } from '@/components/common/FlexibleCRUDTable';
import { DynamicForm } from '@/components/common/DynamicForm';
import { abacEnvironmentAttributeEntity } from '@/config/entities/abacEnvironmentAttributes';
import { abacEnvironmentAttributeService } from '@/services/abac';
import { toast } from 'react-hot-toast';
import { useLanguage } from '@/state/language/LanguageProvider';

const EnvironmentAttributesPage: React.FC = () => {
    const [showForm, setShowForm] = React.useState(false);
  const [editingItem, setEditingItem] = React.useState<any>(null);
  const { t } = useLanguage();

  const handleCreate = () => {
    setEditingItem(null);
    setShowForm(true);
  };

  const handleEdit = (item: any) => {
    setEditingItem(item);
    setShowForm(true);
  };

  const handleToggleStatus = async (id: string, isActive: boolean) => {
    try {
      await abacEnvironmentAttributeService.toggleStatus(id, isActive);
      toast.success(t('abac.environmentAttributeStatusUpdated'));
    } catch (error) {
      toast.error(t('abac.failedToUpdateEnvironmentAttributeStatus'));
    }
  };

  const handleFormSubmit = async (data: any) => {
            try {
      if (editingItem) {
                await abacEnvironmentAttributeService.update(editingItem.id, data);
        toast.success(t('abac.environmentAttributeUpdated'));
      } else {
                await abacEnvironmentAttributeService.create(data);
        toast.success(t('abac.environmentAttributeCreated'));
      }
      setShowForm(false);
      setEditingItem(null);
    } catch (error) {
      console.error('EnvironmentAttributesPage - Error:', error);
      toast.error(t('abac.failedToSaveEnvironmentAttribute'));
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingItem(null);
  };

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">{t('abac.environmentAttributesManagement')}</h1>
        <p className="text-gray-600 mt-2">
          {t('abac.defineAndManageEnvironmentAttributes')}
        </p>
      </div>

      {showForm ? (
        <DynamicForm
          entity={abacEnvironmentAttributeEntity}
          initialData={editingItem}
          onSubmit={handleFormSubmit}
          onCancel={handleFormCancel}
        />
      ) : (
        <FlexibleCRUDTable
          entity={abacEnvironmentAttributeEntity}
          service={abacEnvironmentAttributeService}
          onEdit={handleEdit}
          onToggleStatus={handleToggleStatus}
          onCreate={handleCreate}
          onOperationComplete={() => {
            // This will be called after successful operations (create, update, delete)
            // The table will automatically refresh via loadData() in the component
          }}
        />
      )}
    </div>
  );
};

export default EnvironmentAttributesPage;
